"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _wdh = require("@demant/wdh");

var _componentDataParser = _interopRequireDefault(require("./component-data-parser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ComponentBootstrap = /*#__PURE__*/function (_WDHComponent) {
  _inherits(ComponentBootstrap, _WDHComponent);

  var _super = _createSuper(ComponentBootstrap);

  /**
   * Creates a react ready component based on WDHComponent.
   * Just specify the class name and variation the component
   * should target and supply a react app. The ComponentBootstrap
   * will parse the data from the markup and supply it to the react
   * app as a prop name *settings*. The react app also gets the HTMLDivElement that holds the component in a prop name *component*.
   * @param {string} componentCSSSelector - the css selector for the components to target with this code
   * @inheritdoc
   * @augments WDHComponent
   * @constructor
   * @example
   *
   * import { ComponentBootstrap } from 'demant/react-bootstrap';
   * import introBannerSchema from '@demant/react-bootstrap/lib/schemas';
   *
   * const MyReactApp = ({ settings, component }) => <div>{settings.data.image}</div>;
   * const myComponent = new ComponentBootstrap('.intro-banner');
   * myComponent.schemaData = introBannerSchema;
   * myComponent.reactApp = MyReactApp;
   * myComponent.run();
   */
  function ComponentBootstrap(componentCSSSelector) {
    var _this;

    _classCallCheck(this, ComponentBootstrap);

    _this = _super.call(this, componentCSSSelector);
    /**
     * The CSS selector for the container inside the components markup that the React app should rendered in.
     * @type {string} [.component-content]
     */

    _this.containerCSSSelector = '.component-content';
    /**
     * @typedef SchemaDataDefinition
     * @property {string} name
     * @property {string} element
     * @property {DataType} type
     */

    /**
     * The schema for the data
     * @type {Array.<SchemaDataDefinition>}
     */

    _this.schemaData = null;
    /**
      * The React app that should be rendered for each instance of the component
    */

    _this.reactApp = null;
    /**
      * Parsed data from HTML for external purpose
    */

    _this.parsedDataObject = {};
    return _this;
  }

  _createClass(ComponentBootstrap, [{
    key: "init",
    value: function init(component) {
      var settings = new _componentDataParser["default"](component, this.schemaData).getComponentData();
      var container = component.querySelector(this.containerCSSSelector);
      this.parsedDataObject = {
        settings: settings,
        component: component
      };

      _reactDom["default"].render(_react["default"].createElement(this.reactApp, {
        settings: settings,
        component: component
      }), container);
    }
  }]);

  return ComponentBootstrap;
}(_wdh.WDHComponent);

var _default = ComponentBootstrap;
exports["default"] = _default;